import { createRouter, createWebHistory } from "vue-router";

import DefaultLayout from "@/layout/DefaultLayout.vue";
import AccountingPage from "@/views/AccountingPage.vue";
import AdminAnalytics from "@/views/AdminAnalytics.vue";
import ClinicsView from "@/views/ClinicsView.vue";
import CreateClinicPage from "@/views/CreateClinicPage.vue";
import DashboardView from "@/views/DashboardView.vue";
import LoginPage from "@/views/LoginPage.vue";
import MedicalStaffDetail from "@/views/MedicalStaffDetail.vue";
import NewsView from "@/views/NewsView.vue";
import NotificationsView from "@/views/NotificationsView.vue";
import NursesDoctorsView from "@/views/NursesDoctorsView.vue";
import ReviewView from "@/views/ReviewView.vue";
import RolesView from "@/views/RolesView.vue";
import SupportView from "@/views/SupportView.vue";
import VerificationView from "@/views/VerificationView.vue";
import PluginAnalyticsView from "@/views/PluginAnalyticsView.vue";
import StacionarAnalyticsView from "@/views/StacionarAnalyticsView.vue";

function isAuthenticated() {
  return !!localStorage.getItem("token");
}

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next({ name: "Главная" });
      } else {
        next();
      }
    },
  },

  {
    path: "/",
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "", name: "Главная", component: DashboardView },
      { path: "roles", name: "Роли", component: RolesView },
      { path: "requests", name: "Заявки", component: VerificationView },
      { path: "reviews", name: "Оценки", component: ReviewView },
      { path: "accointing", name: "Бухгалтерия", component: AccountingPage },
      { path: "news", name: "Новости", component: NewsView },
      { path: "clinics", name: "Клиники AI", component: ClinicsView },
      { path: "analytics", name: "Аналитика", component: AdminAnalytics },
      { path: "plugin-analytics", name: "Аналитика плагина", component: PluginAnalyticsView },
      { path: "stacionar-analytics", name: "Аналитика стационара", component: StacionarAnalyticsView },
      { path: "create-clinic", name: "Клиники", component: CreateClinicPage },

      {
        path: "admin/clinics/:clinicId/add-doctor",
        name: "AddClinicDoctor",
        component: () => import("@/views/AddClinicDoctor.vue"),
        props: route => ({ clinicId: Number(route.params.clinicId) })
      },

      {
        path: "admin/clinics/:clinicId/doctors",
        name: "ClinicDoctors",
        component: () => import("@/views/ClinicDoctorsView.vue"),
        props: route => ({ clinicId: Number(route.params.clinicId) })
      },

      { path: "notify", name: "Уведомления", component: NotificationsView },
      { path: "support", name: "Тех поддержка", component: SupportView },
      { path: "medicin_partner", name: "Партнеры", component: NursesDoctorsView },

      {
        path: "medical-info/:id",
        name: "MedicalStaffDetail",
        component: MedicalStaffDetail,
        props: true
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
